<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [list]="items" [colDefs]="module_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)"
  (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <div class="flex gap-2">
      <app-button color="bg-secondary text-[#310000]" [label]="page_name" icon="bx bx-plus"
        (click)="open_form_modal()"></app-button>
      <app-button color="bg-secondary text-[#310000]" [label]="`Add Bulk ${page_name | plural}`" icon="bx bx-plus"
        (click)="bulk_modal.open()"></app-button>
    </div>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No"
  confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true"
  (confirm_modal_clicked)="delet_module()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to delete this record?.
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      <app-select-input label="Module" [options]="ds.dropdown_list.module_list" [is_required]="true" class="w-full"
        formControlName="module_id"></app-select-input>
      <app-text-input [is_required]="true" type="text" class="w-full" [label]="page_name + ' Name'"
        formControlName="name"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]="'Code'" formControlName="code"></app-text-input>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button"
        (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="selected_ids.id ? 'Update' :'Add'" type="button"
        [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5"
    [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>